/**
 * @description Bloc homepage multicontent2
 */

/* global swiperKiller */
(() => {
    // VARS
    const root = document.querySelector(".usine-multicontent-2");

    const addItems = (sk) => {
        const skImages = drupalSettings.yellowstone.homepage_highlight;

        skImages.forEach(img => {
            sk.querySelector('[data-sk-slides]').insertAdjacentHTML(
                "afterbegin",
                `<li class="usine-multicontent-2__list__item" data-sk-slide="" aria-hidden="false"">
                    <img src="${img}"></img>
                </li>`
                ); 
        });
    }
  
    // GO 🚀
    const init = () => {
        const sk = root.querySelector('[data-sk]') || null;

        if (sk) {
            addItems(sk);

            new SwiperKiller(
            `usine-multicontent-2`,
            { xl: 1, lg: 1, md: 1, sm: 1, xs: 1 },
            {
                sliderIndex: 1,
                paddingWrapper: 0,
                infinite: true,
                autoplay: false,
                pagination: false,
            }
            );
        }
    };
  
    init();
  })();
  